import { render, staticRenderFns } from "./CertificationEscalationFile.vue?vue&type=template&id=22cb8028&scoped=true&"
import script from "./CertificationEscalationFile.vue?vue&type=script&lang=js&"
export * from "./CertificationEscalationFile.vue?vue&type=script&lang=js&"
import style0 from "./CertificationEscalationFile.vue?vue&type=style&index=0&id=22cb8028&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cb8028",
  null
  
)

export default component.exports